"use client";

import { EmptyTemplatesStateTypes } from "./EmptyTemplatesState.types";
import { NoTemplates } from "./NoTemplates";
import styles from "./EmptyTemplatesState.module.css";
import { useTranslations } from "@zapier/i18n";
import { EmptyTableDisplay, useRouterParams } from "@zapier/shared";

interface Props {
  tableType: EmptyTemplatesStateTypes;
}

export function EmptyTemplatesState({ tableType }: Props) {
  const t = useTranslations("empty-templates-display");
  const { clearFilterParams } = useRouterParams();

  switch (tableType) {
    case EmptyTemplatesStateTypes.NoTemplates: {
      return (
        <div className={styles.emptyStateWrapper}>
          <div className={styles.gridWrapper}>
            <NoTemplates />
          </div>
        </div>
      );
    }
    case EmptyTemplatesStateTypes.EmptySearch: {
      return (
        <EmptyTableDisplay
          actionButtonText={t("actions.clear-search")}
          headerText={t("headings.no-results-found")}
          icon="navSearch"
          onActionButton={() => clearFilterParams()}
          subHeaderText={t("messages.adjust-filters-or-clear-search")}
        />
      );
    }
    case EmptyTemplatesStateTypes.NoShared: {
      return (
        <EmptyTableDisplay
          icon="navTemplate"
          headerText={t("headings.no-shared-templates")}
          subHeaderText={t("messages.sharing-encourages-collaboration")}
        />
      );
    }
    case EmptyTemplatesStateTypes.NoOwned: {
      return (
        <EmptyTableDisplay
          icon="navTemplate"
          headerText={t("headings.no-templates-created")}
          subHeaderText={t("messages.create-first-template-description")}
        />
      );
    }
    default: {
      return;
    }
  }
}
